import {Box, BoxProps} from '@mui/material'

import {ReactComponent as ProgynyLogoSvgWhite} from '@progyny/assets/images/progyny-logo-white.svg'
import {ReactComponent as ProgynyLogoSvg} from '@progyny/assets/images/progyny.svg'

import {BrandColors} from '@root/theme'

type LogoProps = BoxProps & {
  maxWidth?: string | number
  fill?: keyof BrandColors
  variant?: 'white' | 'blue'
}

const Logo = (props: LogoProps): JSX.Element => {
  const {fill, variant, ...rest} = props

  return (
    <Box
      lineHeight={2}
      {...rest}
      sx={{display: 'flex', flexDirection: 'flex-row', alignItems: 'center'}}
    >
      {variant === 'white' ? (
        <ProgynyLogoSvgWhite width='100%' height='auto' />
      ) : (
        <ProgynyLogoSvg width='100%' height='auto' />
      )}
    </Box>
  )
}

export default Logo
